import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurveLine = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 994 31",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 28L104.864 22.5L190.851 7.72703C191.729 7.57614 192.621 7.52355 193.511 7.57022L277.976 12L364.281 24L449.419 27.9231C450.526 27.9741 451.635 27.8715 452.714 27.6181L536.213 8.01272C537.656 7.67384 539.15 7.60534 540.618 7.81068L624.2 19.5L712.01 21.5L796.576 29.3846C797.399 29.4613 798.227 29.4529 799.048 29.3594L885.624 19.5L992 2",
		stroke: "#E7E5E4",
		strokeWidth: 3,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgCurveLine);
export { ForwardRef as ReactComponent };
